import { SealCheck, MapPin } from "@phosphor-icons/react";
import { COMPANY, IMAGES, RGE_SERVICES } from "../data/site";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Ring } from "../components/Decor";
import CtaBanner from "../components/CtaBanner";

const CHAPTERS = [
  {
    num: "01",
    color: "#FF3123",
    title: "L'artisan de proximité",
    body: "Lisse Energies est une entreprise artisanale spécialisée dans le chauffage, les énergies renouvelables, la climatisation et la plomberie. Basés à Praye, nous intervenons dans tout le Saintois et l'agglomération de Nancy, avec la disponibilité et l'écoute d'un artisan local.",
  },
  {
    num: "02",
    color: "#FC8529",
    title: "L'engagement qualité",
    body: "De l'étude de votre projet à l'entretien de votre installation, nous vous accompagnons à chaque étape avec sérieux et proximité. Qualité, conseil et suivi : nous privilégions un travail durable, propre et adapté à votre logement.",
  },
  {
    num: "03",
    color: "#1A49F7",
    title: "La certification RGE",
    body: `Notre certification RGE (Reconnu Garant de l'Environnement) garantit un travail conforme aux exigences de l'État et vous ouvre l'accès aux aides à la rénovation énergétique — MaPrimeRénov' et CEE — sur vos installations de ${RGE_SERVICES}.`,
  },
];

export default function APropos() {
  return (
    <div data-testid="a-propos-page">
      <PageHero
        index="03"
        eyebrow="À propos"
        title="Votre confort, notre métier."
        intro="Lisse Energies, votre artisan chauffagiste RGE dans le Saintois et à Nancy — avec un vrai accompagnement, du conseil au service après-vente."
      />

      <section className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-7">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.num} delay={i * 0.06}>
                <div className="border-t-2 py-12" style={{ borderColor: `${c.color}33` }}>
                  <div className="flex items-baseline gap-6">
                    <span className="text-2xl font-black" style={{ color: c.color }}>{c.num}</span>
                    <div>
                      <h2 className="text-3xl font-bold tracking-tight text-[#14183A] md:text-4xl">{c.title}</h2>
                      <p className="mt-5 max-w-xl text-lg font-light leading-relaxed text-[#5b6072]">{c.body}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={0.1}>
              <div className="sticky top-24 space-y-6">
                <div className="relative">
                  <Ring color="cyan" className="-right-4 -top-4" size={70} />
                  <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem] bg-[#F3F6FF]">
                    <img src={IMAGES.technicien} alt="Artisan Lisse Energies au travail" className="h-full w-full object-cover" />
                  </div>
                </div>
                <div className="rounded-[1.75rem] border border-[#FC8529]/30 bg-[#FFF6EF] p-8">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-white shadow-sm">
                    <SealCheck weight="light" className="h-7 w-7 text-[#FC8529]" />
                  </span>
                  <p className="mt-4 text-lg font-semibold leading-snug text-[#14183A]">Artisan RGE — éligible MaPrimeRénov' &amp; CEE</p>
                  <p className="mt-3 text-sm text-[#5b6072]">Certification RGE Qualit'EnR.</p>
                  <p className="mt-4 text-sm font-medium text-[#8a90a3]">N° RGE : {COMPANY.rgePlaceholder}</p>
                </div>
                <div className="rounded-[1.75rem] border border-[#E7ECFB] bg-[#F3F6FF] p-8">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-white shadow-sm">
                    <MapPin weight="light" className="h-7 w-7 text-[#1A49F7]" />
                  </span>
                  <p className="mt-4 text-lg font-semibold leading-snug text-[#14183A]">Zone d'intervention</p>
                  <p className="mt-3 text-sm text-[#5b6072]">{COMPANY.zone}, et alentours du 54.</p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
        <div className="h-16 md:h-24" />
      </section>

      <CtaBanner />
    </div>
  );
}
